<template>
  <div class="root">
    <v-header />
    <div class="main1">
      <p class="title">超级简历，让招聘更简单</p>
      <p class="title_msg">让技术更人性化，让招聘更智能化，HR更爱用的智能化招聘管理系统</p>
      <a class="btn shadow" :href="isLogin ? '/talent/search' : '/signin?account_type=hr_account'">立即使用</a>
    </div>
    <img src="https://files.wondercv.com/ldyldymac2.png" class="ldymac">

    <div class="job">
      <div class="title" >
        <div class="label-title">
          <span class="title_left ff64">发职位</span>
          <span>，免费发布职位</span>
        </div>
        <p class="title_msg ">注册成为HR，免费发布热招职位</p>
      </div>
      <div class="job_img">
        <img src="https://files.wondercv.com/ldyldydian2.png" class="dian" />
        <img src="https://files.wondercv.com/ldyldyjob2.png" class="img">
      </div>
      <a class="job_btn shadow" :href="isLogin ? '/talent/joblist' : '/signin?account_type=hr_account'">去发职位</a>
    </div>

    <div class="communication flex">
      <div class="communication_title">
        <div class="label-title">
          <span class="title_left ff64">发起沟通</span>
          <span>，免费主动发起沟通</span> 
        </div>
        <p class="title_msg">候选人在线聊天，快速获得求职意向反馈</p>
      </div>
      <div class="communication_img flex">
        <img src="https://files.wondercv.com/ldyldycommunication2.png" class="img">
        <div class="msg flex">
          <div class="title">
            摆脱聊天人数限制<br />无限发起沟通
          </div>
          <div class="msg_info">
            <p>· 不限次数主动向候选人发送新招呼</p>
            <p>· 每天免费极速联系机会，可直接与候选人交换联系方式</p>
            <p>· 求职者在线极速反馈，快速获得意向反馈</p>
          </div>
          <a class="btn shadow" :href="isLogin ? '/talent/search' : '/signin?account_type=hr_account'">立即使用</a>
        </div>
      </div>
    </div>

    <div class="recommend flex">
      <div class="recommend_title">
        <div class="label-title">
          <span class="title_left ff64">人才推荐</span>
          <span>，高精尖人才推荐</span>
        </div>   
        <p class="title_msg">千万+优质候选人才库</p>
      </div>

      <div class="recommend_img flex">
        <div class="msg flex">
          <div class="title">
            找不到心仪候选人<br />对标招聘需要精准推荐
          </div>
          <div class="msg_info">
            <p>· 根据职位要求推荐高质量人才</p>
            <p>· 查看最新简历，快速获得意向反馈</p>
            <p>· 可设置订阅条件，管理专属人才库</p>
          </div>
          <a class="btn shadow" :href="isLogin ? '/talent/search' : '/signin?account_type=hr_account'">立即使用</a>
        </div>
        <img src="https://files.wondercv.com/ldyldyrecommend2.png" class="img">
      </div>
    </div>

    <div class="custom flex">
      <div class="custom_title">
        <div class="label-title">
          <span class="title_left ff64">专属定制</span>
          <span>，联系商务为你定制</span>
        </div>   
        <p class="title_msg">企业定制，超值优惠</p>
      </div>
      <div class="custom_img flex">
        <img src="https://files.wondercv.com/ldyldycustom2.png" class="img">
        <div class="msg flex">
          <div class="title">
            企业专属招聘方案定制<br />解决找人难、找人慢
          </div>
          <div class="msg_info">
            <p>· 定制专属招聘解决方案，坐拥海量投递</p>
            <p>· 组合购买各类道具/方案，畅享超值优惠</p>
            <p>· 一对一服务，专属顾问指导</p>
          </div>
          <a class="btn shadow" :href="isLogin ? '/talent/search' : '/signin?account_type=hr_account'">立即使用</a>
        </div>
      </div>
    </div>

    <div class="listen">
      <div class="label-title">
         <span class="title_left ff64">听一听</span>
         <span>，HR 们怎么说</span> 
      </div>
      <p class="title_msg">海量职位模版，免费发布</p>
    </div>

    <div class="hr">

      <swiper :options="swiperOption" ref="mySwiper" class="swiper_hr">
        <swiper-slide class="card">
          <div class="msg-body">
            <div class="msg">
              简历样式清晰可见，在简历筛选效率上提高了2倍，节省了很多简历筛选的时间，而且简历质量非常高，一定会持续使用～
            </div>
            <div class="card_hr">
              <img src="https://files.wondercv.com/ldyhrlogo.png" class="img" />
              <div class="info">
                <div class="name">张女士</div>
                <div class="company">学而思/人力资源总监</div>
              </div>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="card">
          <div class="msg-body">
            <div class="msg">
             超级简历以简历编辑工具为切入点，相比于其他平台能更前置的知道C端用户的求职信息，且简历高端完备，有其他平台找不到的优质候选人，超棒哒！
            </div>
            <div class="card_hr">
              <img src="https://files.wondercv.com/ldyhr2.png" class="img" />
              <div class="info">
                <div class="name">贺先生</div>
                <div class="company">美团/HR</div>
              </div>
            </div>
          </div> 
        </swiper-slide>

        <swiper-slide class="card">
          <div class="msg-body">
            <div class="msg">
             超级简历 实时在线和候选人聊天，以及每天都有的免费联系的次数，让每天登陆超级简历和候选人聊天成为了每日必备的日程，希望超级简历越来越好～
            </div>
            <div class="card_hr">
              <img src="https://files.wondercv.com/ldyhr3.png" class="img" />
              <div class="info">
                <div class="name">郝女士</div>
                <div class="company">搜狐畅游/HR</div>
              </div>
            </div>
          </div>
        
        </swiper-slide>
        <swiper-slide class="card">
          <div class="msg-body">
            <div class="msg">
             作为超级简历C端的用户现在做了HR进而使用B端招聘平台，使用的感受就是超级简历整个的产品迭代速度非常快，经常出新功能，在提升招聘效率这块，看好超级简历！
            </div>
            <div class="card_hr">
              <img src="https://files.wondercv.com/ldyhr4.png" class="img" />
              <div class="info">
                <div class="name">艾先生</div>
                <div class="company">蔚来汽车/人力资源主管</div>
              </div>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="card">
          <div class="msg-body">
            <div class="msg">
             使用超级简历有一段时间，最直观的感受是高端的年轻用户很活跃，每次登陆都会有很多候选人投递，希望之后有更多招聘方面的合作机会～
            </div>
            <div class="card_hr">
              <img src="https://files.wondercv.com/ldyhr5.png" class="img" />
              <div class="info">
                <div class="name">王女士</div>
                <div class="company">B站/HR</div>
              </div>
            </div>
          </div>  
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <img src="https://files.wondercv.com/PC/hr/landingpage_logo.png" class="company_img">

      <a class="btn shadow" :href="isLogin ? '/talent/search' : '/signin?account_type=hr_account'">立即使用</a>

    </div>

    <div class="footer">
      <pcFooter :code="true" :link="true" />
    </div>
  </div>
</template>

<script>
import { toLogin, get_tUser } from '@/utils/utils'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import header from './Header'
import pcFooter from '@/components/block/pcFooter'

export default {
  components: {
    swiper,
    pcFooter,
    swiperSlide,
    'v-header': header,
  },
  data() {
    return {
      isLogin: false,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        // centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        // autoplay: {
        //   delay: 5000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
      }
    }
  },
  mounted() {
    this.isLogin = !!(get_tUser().h_t);
    try {
      document.getElementsByTagName('body')[0].className += 'hide-udesk'
    } catch (error) {}

    // let time = null
    // time = setInterval(()=>{
    //   let el = document.getElementById('udesk_container');
    //   if(el){
    //     el.style.display = 'none';
    //     clearInterval(time)
    //   }

    // }, 16)

  },
  methods: {
    storeLocation(url){
      //增加登录之后自动跳转 跳转到相应页面
      toLogin(window.location.origin + '/talent/search')
    },
  }
}
</script>

<style lang="scss" scoped>
.ff64{
  color: #FF6644 !important;
}
/deep/ .swiper-pagination-bullets {
  left: 50% !important;
  transform: translateX(-50%) !important;
}
// /deep/ .swiper-slide-active {
//   transform: translateY(-30px);
//   box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.2);
//   transition: all .3s;
// }
.label-title{
  margin-bottom: 8px;
  span{
    font-weight: 600;
  }
  &>span:nth-child(2) {
    color: #404040 !important;
  }
}
.shadow{
  box-shadow: 0 10px 18px -1px rgba(255 ,94, 59, .35);
  cursor: pointer;
}
  ::v-deep #udesk_container > #udesk_btn > a{
    display: none !important;
  }
.flex {
  display: flex;
}
.bg {
  background-color: #ffffff;
}
.root {
  background-color: #ffffff;
  position: relative;
}
.header {
  background: #1F2A3A;
  padding: 13px 90px 12px 90px;
  justify-content: space-between;
  align-items: center;
  .img {
    width: 102;
    height: 34px;
  }
  .account {
    justify-content: space-between;
    width: 172px;
  }
  .login {
    width: 76px;
    height: 30px;
    border-radius: 15px;
    border: 1px solid #797B7E;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
    // display: inline-block;
  }
  .login:hover {
    cursor: pointer;
  }
  .registered:hover {
    cursor: pointer;
  }
  .registered {
    width: 76px;
    height: 30px;
    background: #4183FF;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
  }
}
.main1 {
  height: 653px;
  width: 100%;
  background: url("https://files.wondercv.com/ldyman1bg2.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  .title {
    font-size: 44px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    padding-top: 74px;
    height: 64px;
  }
  .title_msg {
    font-size: 16px;
    font-weight: 400;
    color: #F7F8F9;
    text-align: center;
    margin-top: 5px;
    height: 30px;
    line-height: 30px;
  }
  .btn {
    display: block;
    width: 300px;
    height: 54px;
    line-height: 54px;
    background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
    border-radius: 27px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0 auto;
    margin-top: 35px;
    &:hover{
      background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%) !important;
    }
  }
}
.ldymac {
  width: 803px;
  height: 549px;
  margin: 0 auto;
  position: absolute;
  top: 400px;
  left: 50%;
  transform: translateX(-50%);
}
.job {
  margin-top: 326px;
  .title {
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    text-align: center;
  }
  .title_left {
    color: #4183FF;
  }
  .title_msg {
    font-size: 22px;
    font-weight: 400;
    color: #959BA3;
    line-height: 30px;
  }
  .job_img {
    width: 1018px;
    height: 470px;
    position: relative;
    margin: 0 auto;
    margin-top: 13px;
    .img {
      margin: 0 auto;
      width: 1018px;
      height: 470px;
      z-index: 5;
      position: absolute;
    }
    .dian {
      position: absolute;
      right: -35px;
      bottom: 10px;
      width: 178px;
      height: 178px;
      z-index: 2;
    }
  }
  .job_btn {
    display: block;
    width: 220px;
    height: 49px;
    background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
    border-radius: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 49px;
    text-align: center;
    margin: 0 auto;
    &:hover{
      background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%) !important;
    }
  }
}
.communication {
  margin-top: 91px;
  padding: 0 100px;
  flex-direction: column;
  .communication_title {
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    text-align: center;
    .title_left {
      color: #4183FF;
    }
    .title_msg {
      font-size: 22px;
      font-weight: 400;
      color: #959BA3;
      line-height: 30px;
    }
  }
  .communication_img {
    align-items: center;
    margin: 0 auto;
    margin-top: 61px;
    .img {
      width: 749px;
      height: 538px;
      object-fit: contain;
      display: inline-block;
      margin-right: 20px;
    }
    .title {
      width: 373px;
      height: 80px;
      font-size: 28px;
      font-weight: 400;
      color: #404040;
      line-height: 40px;
    }
    .msg {
      flex-direction: column;
      align-self: center;
      transform: translateY(-20px);

      .title {
        height: 80px;
        font-size: 28px;
        font-weight: 400;
        color: #404040;
        line-height: 40px;
      }

      .msg_info {
        margin-top: 30px;
        font-size: 15px;
        font-weight: 400;
        color: #959BA3;
        line-height: 23px;
        p {
          margin-bottom: 14px;
        }
      }
      .btn {
        display: block;
        margin-top: 25px;
        width: 220px;
        height: 49px;
        background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
        border-radius: 25px;
        &:hover{
          background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%);
        }
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 49px;
        text-align: center;
      }
    }
  }
}
.recommend {
  margin-top: 92px;
  padding: 0 100px;
  flex-direction: column;

  .recommend_title {
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    text-align: center;
    span {
      color: #4183FF;
    }
    .title_msg {
      font-size: 22px;
      font-weight: 400;
      color: #959BA3;
      line-height: 30px;
    }
  }
  .recommend_img {
    align-items: center;
    margin: 0 auto;
    margin-top: 31px;
    padding-left: 70px;
    .img {
      width: 749px;
      height: 538px;
      object-fit: contain;
    }
    .msg {
      flex-direction: column;
      align-self: center;
      transform: translateY(-20px);
      .title {
        font-size: 28px;
        font-weight: 400;
        color: #404040;
        line-height: 40px;
      }
      .msg_info {
        margin-top: 30px;
        font-size: 15px;
        font-weight: 400;
        color: #959BA3;
        line-height: 23px;
        p {
          margin-bottom: 14px;
        }
      }
      .btn {
        display: block;
        margin-top: 25px;
        width: 220px;
        height: 49px;
        background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
        border-radius: 25px;
        &:hover{
          background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%);
        }
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 49px;
        text-align: center;
      }
    }
  }
}

.custom {
  margin-top: 91px;
  padding: 0 100px;
  flex-direction: column;
  .custom_title {
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    text-align: center;
    .title_left {
      color: #4183FF;
    }
    .title_msg {
      font-size: 22px;
      font-weight: 400;
      color: #959BA3;
      line-height: 30px;
    }
  }
  .custom_img {
    align-items: center;
    margin: 0 auto;
    margin-top: 55px;
    .img {
      width: 749px;
      height: 538px;
      object-fit: contain;
      display: inline-block;
      margin-right: 30px;
    }
    .title {
      width: 373px;
      height: 80px;
      font-size: 28px;
      font-weight: 400;
      color: #404040;
      line-height: 40px;
    }
    .msg {
      flex-direction: column;
      align-self: center;
      transform: translateY(-20px);

      .title {
        height: 80px;
        font-size: 28px;
        font-weight: 400;
        color: #404040;
        line-height: 40px;
      }

      .msg_info {
        margin-top: 30px;
        font-size: 15px;
        font-weight: 400;
        color: #959BA3;
        line-height: 23px;
        p {
          margin-bottom: 14px;
        }
      }
      .btn {
        display: block;
        margin-top: 25px;
        width: 220px;
        height: 49px;
        background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
        border-radius: 25px;
        &:hover{
          background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%);
        }
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 49px;
        text-align: center;
      }
    }
  }
}

.listen {
  margin-top: 91px;
  margin-bottom: 72px;
  font-size: 48px;
  font-weight: 600;
  line-height: 67px;
  text-align: center;
  .title_left {
    color: #4183FF;
  }
  .title_msg {
    font-size: 22px;
    font-weight: 400;
    color: #959BA3;
    line-height: 30px;
  }
}

.hr {
  // min-width: 1440px;
  padding-left: 50px;
  padding-top: 54px;
  padding-bottom: 96px;
  background: linear-gradient(134deg, #333F51 0%, #1F2A3A 100%);
  .company_img {
    margin: 0 auto;
    margin-top: 72px;
    width: 1083px;
    height: 388px;
  }
  .btn {
    display: block;
    width: 300px;
    height: 54px;
    background: linear-gradient(90deg, #FF9C62 0%, #FF6030 100%);
    border-radius: 27px;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 54px;
    margin: 85px auto 0px;
    &:hover{
      background: linear-gradient(90deg, #FFA570 0%, #FF7146 100%);
    }
  }
}

.swiper_hr {
  height: 285px;
  padding-top: 36px;
  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    .msg-body{
      padding: 42px 48px 34px 48px;
    }
    .msg {
      font-size: 18px;
      font-weight: 400;
      color: #222A41;   
      line-height: 32px;
      text-shadow: 0px 20px 40px rgba(0, 0, 0, 0.2);
    }
    .card_hr {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 60px;
        height: 60px;
        margin-right: 18px;
      }
      .name {
        font-size: 21px;
        font-weight: 400;
        color: #000000;
        letter-spacing: 1px;
        text-shadow: 0px 20px 40px rgba(0, 0, 0, 0.2);
      }
      .company {
        margin-top: 5px;
        color: #898989;
      }
    }

  }
}
/deep/ .swiper-slide {
  width: 600px !important;
  height: 260px !important;
  border-radius: 28px;
  background: #ffffff;

}
.swiper-container {
  /* transform: translateX(-50px); */
}
.swiper-pagination {
  // transform: translateY(-60px);

}
.flex_shrink {
  flex-shrink: 0;
}
.loop {
  .card {
    height: 316px;
    border-radius: 28px;
    background: #ffffff;
  }
}
</style>

